import React, { useCallback } from 'react';
import { SearchIcon } from '../svg/SearchIcon';
import { useForm } from 'react-hook-form';
type Props = {
    className?: string;
    placeholder?: string;
    defaultValue?: string;
    onSearch: (value: string) => void;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    hasSearchButton?: boolean;
    handleEnterEvent?(event: React.KeyboardEvent);
};

type SearchFormValues = {
    searchText: string;
};

export const SearchBar: React.FC<Props> = ({
    className,
    placeholder,
    defaultValue,
    onSearch,
    onChange,
    handleEnterEvent,
}) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isSubmitting },
    } = useForm<SearchFormValues>();
    const onSubmit = useCallback(
        async (values: SearchFormValues) => {
            const { searchText } = values;
            onSearch(searchText);
        },
        [onSearch],
    );

    return (
        <form
            className={`search-bar${className ? ` ${className}` : ''}`}
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)(e);
            }}
        >
            <label htmlFor={'search'}>{'Search'}</label>
            <input
                onKeyPress={handleEnterEvent}
                {...register('searchText')}
                className={`input-field`}
                onChange={onChange}
                placeholder={placeholder ?? 'Search...'}
                autoComplete="off"
                defaultValue={defaultValue}
            />
            <button type="submit" className="search-button">
                <SearchIcon />
            </button>
        </form>
    );
};
